import { clsx } from 'clsx'
import { type ComponentProps, type FC } from 'react'

import { useLocaleContext } from '../LocaleContext'

type CircularProgressProps = ComponentProps<'span'>

/**
 * Progress indicators, commonly known as spinners, express an unspecified wait time or display the length of a process.
 *
 * Inspired by MUI [CircularProgress](https://github.com/mui/material-ui/blob/fc23da8a6bc0872d7ebd71b7f78c7502aeb95aa3/packages/mui-material/src/CircularProgress/CircularProgress.js).
 */
export const CircularProgress: FC<CircularProgressProps> = (props) => {
  const { className, ...rest } = props
  const { loading } = useLocaleContext().circularProgress

  return (
    <span
      aria-label={loading}
      className={clsx('circular-progress', className)}
      role="progressbar"
      {...rest}
    >
      <svg aria-hidden viewBox="22 22 44 44">
        <circle cx="44" cy="44" r="20.2" />
      </svg>
    </span>
  )
}
